var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300 0H0V300H300V0ZM246.25 66.2904C256.788 69.1407 265.097 77.485 267.932 88.0704C273.202 107.404 272.999 147.704 272.999 147.704C272.999 147.704 272.999 187.798 267.935 207.133C265.097 217.717 256.789 226.061 246.25 228.91C227 234 150 234 150 234C150 234 73.2002 234 53.7486 228.708C43.2098 225.858 34.9037 217.513 32.066 206.93C27 187.798 27 147.5 27 147.5C27 147.5 27 107.404 32.066 88.0704C34.9007 77.4865 43.4125 68.9371 53.7471 66.0898C72.9975 61 149.997 61 149.997 61C149.997 61 227 61 246.25 66.2904ZM189.513 147.5L125.481 110.458V184.542L189.513 147.5Z",
    fill: "#0057b8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b0a5a8d90614fe9e8ee6f45a9047df69.svg";
export { ForwardRef as ReactComponent };